import { render } from "./InstallationXD.vue?vue&type=template&id=8eae0a90&scoped=true"
import script from "./InstallationXD.vue?vue&type=script&lang=js"
export * from "./InstallationXD.vue?vue&type=script&lang=js"

import "./InstallationXD.vue?vue&type=style&index=0&id=8eae0a90&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\47959\\OneDrive\\Documents\\GitHub\\Poesiparken\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8eae0a90"]])

export default __exports__